export default {
  CUSTOMER_API: "https://customer2.api.driftqa.com",
  CONVERSATION_API: "https://conversation2.api.driftqa.com",
  ACCOUNTS_API: "https://account.api.driftqa.com",
  PAGES_HOST: "driftqa.click",
  WS_API: "https://ws.api.driftqa.com",
  WS: "wss://ws.api.driftqa.com",
  SALES_INBOX_ID: 44,
  SALES_USER_ID: 46894,
  CUSTOMER_WEB_URL: "https://app.driftqa.com",
  LETS_GO_URL: window.location && window.location.origin === "http://localhost:8000" ? "http://localhost:8000" : "https://app.driftqa.com",
  TESTCAFE_REDIRECT_URL: "http://localhost:8000",
  START_WEB_URL: "https://start.driftqa.com",
  DEFAULT_CLIENT_ID: "W41NvthhICG4VC",
  GOOGLE_CLIENT_ID: "519208343067-nl6fp3es3cfqifpotab43kjqg7f85ssc.apps.googleusercontent.com",
  MICROSOFT_CALENDAR_CLIENT_ID: "14eeaf85-cfbb-45c6-84fb-0541d2121f9b",
  CLIENT_ID: "nwr5icbhx5d4ur",
  CLIENT_ID_REDIRECT_URI: "https://app.driftqa.com",
  ONE_TIME_TOKEN: "driftt",
  ONBOARDING_URL: "https://app.driftqa.com/letsgo",
  SENTRY_ID: "https://af5b94f0cb4f4b21ac8ba242fde9f7e2@sentry.io/1311407",
  SAML_CLIENT_ID: "tKi509ARyE3gqS",
  SPLIT_ID: "ncjqpiao38jfrada4mtntpt0emgilspe6tqo",
  PROFILES_WEB_URL: "https://driftqa.me/",
  MARKETO_ID: "802-BEU-656",
  MICROSOFT_OAUTH_BASE_URL: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
  INTERACTION_ID: 303531,
  DRIFT_VIDEO_URL: "https://app-qa.video.drift.com",
  DRIFT_VIDEO_LOGIN_REDIRECT_URL: "https://app-qa.video.drift.com/accounts/login-redirect",
  DRIFT_VIDEO_INVITE_REDIRECT_URL: "https://app-qa.video.drift.com/accounts/invite-redirect",
  DRIFT_VIDEO_HOMEPAGE: "https://app-qa.video.drift.com",
  DRIFT_VIDEO_EXTENSION_URL: "https://chrome.google.com/webstore/detail/drift-videoq/onhoaiplbgahingahhbdkolkhkcgamhh",
  DRIFT_VIDEO_EXTENSION_ID: "onhoaiplbgahingahhbdkolkhkcgamhh",
  WEB_PUSH_SERVER_PUBLIC_KEY: "BNcmBXOKZwIABd72e1H_DG1tyKMf6P4wKH7q8qkjMpHe6JIODFIn0mPOeT9Tq94WiABYq2818rFGKiiWExKJtWA="
}



// WEBPACK FOOTER //
// ./src/config/qa.js